import React, { Fragment } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faEye, faTrash } from '@fortawesome/free-solid-svg-icons'
import RhService from "../../../../../../services/rh";

const Holerite = (props) => {
    const nomeMes = [
        "",            // índice 0 (não usado)
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro",
        "13º Salário - 1ª Parcela",
        "13º Salário - 2ª Parcela",
        "Informe Anual de Rendimentos"
    ];
    const visualizar = async () => {
        try {
            const response = await RhService.viewHolerite(props.funcId, props.holerite._id);
            const blob = new Blob([response.data], { type: "application/pdf" });
            const url = URL.createObjectURL(blob);
            window.open(url, "_blank");
        } catch (error) {
            alert("Erro ao abrir holerite");
        }
    };

    const onEditar = async (fId, hId) => {
        props.editar(fId, hId)
    }

    const deletar = async (fId, hId) => {
        props.deletar(fId, hId)
    }

    return (
        <Fragment>
            <tr>
                <td>{nomeMes[props.holerite.mes]}/{props.holerite.ano}</td>

                <td style={{ whiteSpace: "nowrap" }}>
                    <FontAwesomeIcon
                        onClick={visualizar}
                        icon={faEye}
                        className="mx-2 text-warning cursor-pointer"
                        title="Ver Holerite"
                    />
                </td>

                <td style={{ whiteSpace: "nowrap" }}>
                    <FontAwesomeIcon
                        icon={faPenToSquare}
                        className="mx-2 text-warning cursor-pointer"
                        title="Editar"
                        onClick={() => onEditar(props.funcId, props.holerite._id)}
                    />
                </td>
                <td style={{ whiteSpace: "nowrap" }}>
                    <FontAwesomeIcon
                        icon={faTrash}
                        className="mx-2 text-warning cursor-pointer"
                        title="Apagar"
                        onClick={() => deletar(props.funcId, props.holerite._id)}
                    />
                </td>
            </tr>
        </Fragment>
    )
}

export default Holerite;